export enum SupportedHourlyRentalTypes {
  HOURLY = 'HOURLY',
  SWIMMING_TOUR = 'SWIMMING_TOUR',
}

export enum SupportedDailyWeeklyRentalTypes {
  WEEKLY = 'WEEKLY',
  DAILY = 'DAILY',
  HALF_DAY = 'HALF_DAY',
}
